import {Component, Injector, OnInit} from '@angular/core';
import {CompanyService} from "../../services/company/company.service";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute} from '@angular/router';
import {Company} from "../../models/company";

type CopyField = 'iban' | 'beneficiary' | 'reason';

@Component({
    selector: 'app-iban-page',
    templateUrl: './iban-page.component.html'
})
export class IbanPageComponent extends BaseComponent implements OnInit {

    companyId: string = localStorage.getItem('wisper_companyId') ?? '';
    company: Company = new Company();
    wireTransferIban: string = '';
    wireTransferBeneficiary: string = '';
    /** true = bonifico (mostra IBAN), false = pagamento in segreteria. */
    isFlagged = false;
    orderNumber: string | null = '';
    loading = true;
    copiedField: CopyField | null = null;

    private copiedTimeout: ReturnType<typeof setTimeout> | null = null;

    constructor(public companyService: CompanyService, public serviceInjector: Injector, private route: ActivatedRoute) {
        super(serviceInjector)
    }

    async ngOnInit() {
        const params = this.route.snapshot.queryParamMap;
        this.isFlagged = !!params.get('ibanSelected') && params.get('ibanSelected') !== 'false';
        this.orderNumber = params.get('orderNum');

        try {
            const response: any = await this.companyService.getCompanyById(this.companyId);
            if (response?.success) {
                this.company = response.data;
                this.wireTransferIban = response.data.wireTransferIban ?? '';
                this.wireTransferBeneficiary = response.data.wireTransferBeneficiary ?? '';
            }
        } catch (e) {
            console.error('error getting iban data: ', e);
        } finally {
            this.loading = false;
        }
    }

    get isShopOrder(): boolean {
        return !this.isEmpty(this.orderNumber ?? '');
    }

    /** IBAN a gruppi di 4 caratteri, più leggibile. */
    get formattedIban(): string {
        return (this.wireTransferIban || '').replace(/\s+/g, '').replace(/(.{4})(?=.)/g, '$1 ');
    }

    get transferReason(): string {
        return this.isShopOrder
            ? `Ordine n. ${this.orderNumber} - nome e cognome dell'acquirente`
            : "Nome, cognome e categoria dell'atleta";
    }

    get companyAddress(): string {
        const c = this.company;
        const street = [c.address, c.addressNumber].filter(Boolean).join(' ');
        const city = [c.zip, c.city, c.province ? `(${c.province})` : ''].filter(Boolean).join(' ');
        return [street, city].filter(Boolean).join(', ');
    }

    get backRoute(): string[] {
        return this.isShopOrder ? ['/shop/products'] : ['/users/dashboard'];
    }

    async copy(field: CopyField) {
        const value = field === 'iban' ? this.wireTransferIban.replace(/\s+/g, '')
            : field === 'beneficiary' ? this.wireTransferBeneficiary
                : this.transferReason;
        try {
            await navigator.clipboard.writeText(value);
            this.copiedField = field;
            if (this.copiedTimeout) clearTimeout(this.copiedTimeout);
            this.copiedTimeout = setTimeout(() => this.copiedField = null, 2000);
        } catch (e) {
            console.error('clipboard error: ', e);
        }
    }
}
